var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2715 0.159151L49.8429 24.7295C50.0582 24.9447 50.0174 25.0494 49.7149 25.0494H25.766C25.4461 25.0494 25.4112 25.1716 25.6555 25.4101L49.8429 49.5907C50.1105 49.8641 50.0406 49.9978 49.6335 49.9978C33.2875 50.0036 16.8426 49.9978 0.293033 49.9804C0.217411 49.9804 0.153448 49.9513 0.101095 49.8989C0.0487409 49.8466 0.019647 49.7826 0.019647 49.707C0.00219579 33.1581 -0.00363833 16.7139 0.00217874 0.368585C0.00217874 -0.0385942 0.135943 -0.108423 0.409346 0.159151L24.591 24.3456C24.8295 24.5899 24.9516 24.555 24.9516 24.2351V0.28714C24.9516 -0.0153353 25.0563 -0.0560716 25.2715 0.159151ZM0.898031 25.061C0.735153 25.061 0.647908 25.2647 0.76425 25.381L24.6491 49.2649C24.7655 49.3813 24.9691 49.294 24.9691 49.1311V25.2472C24.9691 25.1425 24.8876 25.061 24.7829 25.061H0.898031Z",
    fill: "#FF6BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/_7.e52cbd01a80edee79e9adb3db7629277.svg";
export { ForwardRef as ReactComponent };